import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';

@Injectable()
export class HttpCustomerHeaderInterceptor implements HttpInterceptor {
  constructor() {}

  /**
   * Intercepts http customer header interceptor - added custom headers to each http request
   * @param request http request
   * @param next http handle
   * @returns intercept
   */

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const timestamp = Date.now();
    let urlWithTimeStamp = '';
    if (request.url.includes('?')) {
      urlWithTimeStamp = `${request.url}&${timestamp}`;
    } else {
      urlWithTimeStamp = `${request.url}?${timestamp}`;
    }

    request = request.clone({
      url: urlWithTimeStamp,
      setHeaders: {
        'X-RequestId': uuid(),
      },
    });
    return next.handle(request);
  }
}
